import { getTrackingSnippet } from '@booking-portal/api/services/tracking-snipptes-service';
import { useQuery } from '@tanstack/vue-query';
import type { MaybeRef } from 'vue';
import { computed, ref, toValue } from 'vue';

export function useTrackingSnippetQuery(
  enable: MaybeRef<boolean>,
  locationId?: MaybeRef<number | undefined | null>
) {
  const enableRef = ref(enable);
  return useQuery({
    queryKey: ['snippet', locationId],
    queryFn: () => getTrackingSnippet(toValue(locationId)),
    enabled: computed(
      () => enableRef.value && toValue(locationId) !== undefined
    ),
    staleTime: Number.MAX_SAFE_INTEGER,
    retry: 3,
    retryDelay: 1000,
  });
}
